import React from 'react'

// Miniaturki artykułów Bazy wiedzy. Rysowane divami (bez plików graficznych) —
// dzięki temu nie ma czego dogrywać przy dodaniu artykułu i nic się nie ładuje z sieci.
// Wspólne dla kart w /baza-wiedzy (variant="card") i listy na stronie głównej (variant="thumb").

const ART = {
  // Falownik 1- vs 3-fazowy: jedna faza wysoka, dwie niskie.
  phase: (
    <span className="flex items-end gap-1" aria-hidden="true">
      <span className="w-2 rounded-t bg-blue-500" style={{ height: 26 }} />
      <span className="w-2 rounded-t bg-blue-300" style={{ height: 15 }} />
      <span className="w-2 rounded-t bg-blue-300" style={{ height: 15 }} />
    </span>
  ),
  // Bilansowanie międzyfazowe: L1 aktywna, suma.
  balancing: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="rounded bg-white border border-gray-200 px-2 py-1 text-[10px] font-medium text-blue-600">L1</span>
      <span className="text-gray-300">·</span>
      <span className="rounded bg-white border border-gray-200 px-2 py-1 text-[10px] text-gray-400">L2</span>
      <span className="rounded bg-white border border-gray-200 px-2 py-1 text-[10px] text-gray-400">L3</span>
      <span className="ml-1 text-sm font-bold text-blue-500">Σ</span>
    </span>
  ),
  // Porównanie ofert: trzy warianty, jeden wybrany — nie zawsze najtańszy.
  offers: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="rounded bg-white border border-gray-200 px-2.5 py-1 text-[10px] font-medium text-gray-400">A</span>
      <span className="rounded bg-blue-600 px-2.5 py-1.5 text-[10px] font-semibold text-white shadow-sm">B ✓</span>
      <span className="rounded bg-white border border-gray-200 px-2.5 py-1 text-[10px] font-medium text-gray-400">C</span>
    </span>
  ),
  // Dobór magazynu: bateria z częściowo wypełnionymi segmentami.
  storage: (
    <span className="flex items-center gap-3" aria-hidden="true">
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-blue-500 p-0.5">
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-100" />
        </span>
        <span className="w-1 h-2.5 rounded-r bg-blue-500" />
      </span>
      <span className="text-lg font-extrabold text-blue-600">kWh</span>
    </span>
  ),
  // Zgodność falownika z magazynem: falownik, połączenie potwierdzone, bateria.
  compat: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="rounded bg-white border border-gray-200 px-2 py-1 text-[10px] font-medium text-gray-500">INV</span>
      <span className="text-[11px] font-bold text-blue-600">✓</span>
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-blue-500 p-0.5">
          <span className="w-2 h-4 rounded-sm bg-blue-500" />
          <span className="w-2 h-4 rounded-sm bg-blue-500" />
        </span>
        <span className="w-0.5 h-2 rounded-r bg-blue-500" />
      </span>
    </span>
  ),
  // Formalności u operatora sieci: druk zgłoszenia z odhaczonymi polami.
  osd: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="flex flex-col gap-1 rounded bg-white border border-gray-200 px-2 py-1.5">
        <span className="w-8 h-1 rounded bg-blue-500" />
        <span className="w-6 h-1 rounded bg-blue-200" />
        <span className="w-7 h-1 rounded bg-blue-200" />
      </span>
      <span className="text-[11px] font-bold text-blue-600">OSD ✓</span>
    </span>
  ),
  // Łańcuch modułów (string) wpięty w jedno wejście MPPT.
  string: (
    <span className="flex items-center gap-1.5" aria-hidden="true">
      <span className="w-3.5 h-5 rounded-sm bg-blue-500" />
      <span className="w-3.5 h-5 rounded-sm bg-blue-500" />
      <span className="w-3.5 h-5 rounded-sm bg-blue-500" />
      <span className="w-3.5 h-5 rounded-sm bg-blue-300" />
      <span className="ml-1 rounded bg-white border border-gray-200 px-1.5 py-0.5 text-[10px] font-medium text-blue-600">MPPT</span>
    </span>
  ),
  // Magazyn dokładany do istniejącej instalacji: moduł PV, plus, bateria.
  retrofit: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="w-5 h-5 rounded-sm bg-blue-500" />
      <span className="text-base font-bold text-blue-600">+</span>
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-blue-500 p-0.5">
          <span className="w-2 h-4 rounded-sm bg-blue-500" />
          <span className="w-2 h-4 rounded-sm bg-blue-100" />
        </span>
        <span className="w-0.5 h-2 rounded-r bg-blue-500" />
      </span>
    </span>
  ),
  // Diagnostyka: panel — przerwane połączenie — pusty magazyn i ostrzeżenie.
  diagnostics: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="w-5 h-5 rounded-sm bg-blue-500" />
      <span className="text-[11px] tracking-[0.2em] text-gray-300">– –</span>
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-gray-300 p-0.5">
          <span className="w-2 h-4 rounded-sm bg-gray-100" />
          <span className="w-2 h-4 rounded-sm bg-gray-100" />
        </span>
        <span className="w-0.5 h-2 rounded-r bg-gray-300" />
      </span>
      <span className="ml-0.5 text-base font-bold text-amber-500">!</span>
    </span>
  ),
  // Dobór modułu do rozbudowy: istniejące moduły + jeden dokładany (dopasowanie).
  'panel-match': (
    <span className="flex items-center gap-1.5" aria-hidden="true">
      <span className="w-5 h-7 rounded-sm bg-blue-500" />
      <span className="w-5 h-7 rounded-sm bg-blue-500" />
      <span className="text-blue-400 text-lg font-bold">+</span>
      <span className="w-5 h-7 rounded-sm bg-white border-2 border-dashed border-blue-400" />
    </span>
  ),
  // Mieszanie modułów: różne moduły obok siebie + znak zapytania.
  'panel-mix': (
    <span className="flex items-end gap-1.5" aria-hidden="true">
      <span className="w-5 h-7 rounded-sm bg-blue-500" />
      <span className="w-5 h-5 rounded-sm bg-gray-800" />
      <span className="w-5 h-6 rounded-sm bg-blue-300" />
      <span className="ml-0.5 text-base font-bold text-amber-500">?</span>
    </span>
  ),
  // Dotacja na magazyn: pełna bateria + moneta „zł".
  subsidy: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-blue-500 p-0.5">
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
        </span>
        <span className="w-1 h-2.5 rounded-r bg-blue-500" />
      </span>
      <span className="text-gray-300 text-lg leading-none">+</span>
      <span className="w-7 h-7 rounded-full bg-amber-400 text-white text-[10px] font-bold flex items-center justify-center shadow-[0_0_0_3px_rgba(251,191,36,0.25)]">zł</span>
    </span>
  ),
  // Cena dynamiczna: słupki cen godzinowych z dołkiem w południe i szczytem wieczorem.
  'dynamic-price': (
    <span className="flex items-end gap-1" aria-hidden="true">
      {[14, 12, 9, 4, 2, 5, 11, 22, 26, 16].map((h, i) => (
        <span key={i} className={`w-1.5 rounded-t ${h >= 20 ? 'bg-amber-500' : h <= 4 ? 'bg-emerald-500' : 'bg-blue-400'}`} style={{ height: h }} />
      ))}
    </span>
  ),
  // Magazyn na cenie dynamicznej: bateria obok słupków cen.
  'battery-price': (
    <span className="flex items-center gap-3" aria-hidden="true">
      <span className="flex items-center">
        <span className="flex gap-0.5 rounded border-2 border-blue-500 p-0.5">
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-500" />
          <span className="w-2.5 h-5 rounded-sm bg-blue-100" />
        </span>
        <span className="w-1 h-2.5 rounded-r bg-blue-500" />
      </span>
      <span className="flex items-end gap-0.5">
        {[10, 4, 2, 8, 18, 22].map((h, i) => (
          <span key={i} className={`w-1.5 rounded-t ${h >= 18 ? 'bg-amber-500' : h <= 4 ? 'bg-emerald-500' : 'bg-blue-300'}`} style={{ height: h }} />
        ))}
      </span>
    </span>
  ),
  // Wallbox: piorun (moc) + kW. Filar „11 czy 22 kW".
  wallbox: (
    <span className="flex items-center gap-2" aria-hidden="true">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" className="text-blue-500"><path d="M13 2 3 14h7l-1 8 10-13h-7l1-7z" /></svg>
      <span className="text-lg font-extrabold text-blue-600">kW</span>
    </span>
  ),
  // Ładowanie z PV: słońce → piorun.
  'solar-ev': (
    <span className="flex items-center gap-2" aria-hidden="true">
      <span className="w-5 h-5 rounded-full bg-amber-400 shadow-[0_0_0_3px_rgba(251,191,36,0.25)]" />
      <span className="text-gray-300 text-lg leading-none">→</span>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-blue-500"><path d="M13 2 3 14h7l-1 8 10-13h-7l1-7z" /></svg>
    </span>
  ),
  // Strony per model auta: sylwetka auta + piorun.
  'ev-model': (
    <span className="flex items-center gap-2.5" aria-hidden="true">
      <span className="relative block w-14 h-7">
        <span className="absolute left-3 top-0 w-8 h-3 rounded-t-md bg-blue-300" />
        <span className="absolute left-0 top-2.5 w-14 h-3.5 rounded-md bg-blue-500" />
        <span className="absolute left-2 bottom-0 w-3 h-3 rounded-full bg-gray-600 border-2 border-white" />
        <span className="absolute right-2 bottom-0 w-3 h-3 rounded-full bg-gray-600 border-2 border-white" />
      </span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="text-blue-500"><path d="M13 2 3 14h7l-1 8 10-13h-7l1-7z" /></svg>
    </span>
  ),
}

const CAPTION = { phase: '3,68 kW', wallbox: '11 · 22 kW', subsidy: 'do 16 000 zł' }

const FALLBACK = (
  <span className="text-xs font-semibold uppercase tracking-wide text-blue-500/70">Baza wiedzy</span>
)

const KbCover = ({ cover, variant = 'card' }) => {
  const art = ART[cover]
  const caption = CAPTION[cover]

  if (variant === 'thumb') {
    // Miniaturka 64×64 — ta sama grafika przeskalowana, bez podpisu tekstowego.
    // Skala 0,5 dobrana tak, by NAJSZERSZA z grafik (offers ~110 px) zmieściła się
    // w kwadracie; overflow-hidden jest zabezpieczeniem na przyszłe, szersze motywy.
    return (
      <div className="w-16 h-16 flex-shrink-0 rounded-lg bg-gradient-to-br from-blue-50 to-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden">
        <span className="scale-50 origin-center whitespace-nowrap">{art || FALLBACK}</span>
      </div>
    )
  }

  return (
    <div className="h-24 bg-gradient-to-br from-blue-50 to-gray-50 border-b border-gray-100 flex items-center justify-center gap-3">
      {art || FALLBACK}
      {caption && <span className="text-lg font-extrabold text-blue-600">{caption}</span>}
    </div>
  )
}

export default KbCover
